import { sanitizeRedirect } from "@/features/auth/redirect";
import { SessionGuard } from "@/features/auth/session-guard";
import { useAuthStore } from "@/features/auth/store";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed")({
  beforeLoad: ({ location }) => {
    const state = useAuthStore.getState();
    if (!state.isAuthenticated()) {
      // IR-1288: carry the attempted page to /login so a re-login restores it.
      // This is the reload / deep-link path; SessionController covers a session
      // that dies while the operator is sitting on a page.
      // `exactOptionalPropertyTypes` — omit the key rather than pass undefined.
      const back = sanitizeRedirect(location.href);
      throw redirect({ to: "/login", search: back ? { redirect: back } : {} });
    }
    if (state.user && state.user.is_ops_staff === false) {
      throw redirect({ to: "/403" });
    }
  },
  // SessionGuard (IR-1241) runs only inside the authed subtree: reactive logout
  // + inactivity timer. It unmounts on redirect to /login, so its timers never
  // run on the login screen.
  component: () => (
    <>
      <SessionGuard />
      <Outlet />
    </>
  ),
});
